<template>
  <div v-if="license_requests.length > 0">
    <div class="mt-5 main-box no-header clearfix">
      <div class="main-box-body clearfix">
        <div class="table-responsive">
          <table class="table user-list table-bordered">
            <thead>
              <tr>
                <th
                  colspan="6"
                  class="text-center">
                  <h3>List of requests</h3>
                </th>
              </tr>
            </thead>

            <tr class="table-second-header">
              <th>
                <span>Creation date</span>
              </th>

              <th>
                <span>Expiration date</span>
              </th>
              <th>
                <span>Mac Address</span>
              </th>
              <th>
                <span>Harddisk serial number</span>
              </th>
              <th>
                <span>Comments</span>
              </th>
              <th>
                <span>Actions</span>
              </th>
            </tr>

            <tr
              v-for="(license_request, index) in license_requests"
              :key="index">
              <td>
                <span class="user-subhead">{{ license_request.created_at }}</span>
              </td>
              <td>
                <label>{{ license_request.expiration_date }}</label>
              </td>

              <td class="text-center">
                <span class="label label-default">{{ license_request.mac_address }}</span>
              </td>

              <td>
                <span class="label label-default">{{ license_request.hdd }}</span>
              </td>

              <td
                class="text-center"
                style="min-width:30%">
                <span class="label label-default">{{ license_request.comments }}</span>
              </td>

              <td class="text-center">
                <a
                  class="table-link"
                  @click="onDelete(license_request.id)">
                  <font-awesome-icon
                    size="lg"
                    icon="trash-alt" />
                </a>
                <template v-if="$route.name === 'users.edit'" >
                  <a
                    class="table-link"
                    @click.prevent="applyRequest(license_request.mac_address,
                                                 license_request.expiration_date, license_request.hdd)">
                    <font-awesome-icon
                      size="lg"
                      icon="puzzle-piece"/>
                  </a>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { vp } from '@/tools/helpers'
import moment from 'moment'
import store from '@/store'

export default {
  props: {
    user_id: [Number, String]
  },
  data () {
    return {
      loading: false,
      saving: false,
      license_requests: [
        {
          id: null,
          expiration_date: null,
          mac_address: null,
          hdd: null,
          created_at: null,
          comments: null
        }
      ]
    }
  },
  created () {
    this.fetchLicRequest()
  },
  methods: {
    async fetchLicRequest () {
      // this.loading = true;
      this.license_requests = await this.$get(
        'users/list_licence_request/' + this.user_id
      )
      // this.loading = false;
    },
    async onDelete (id) {
      // this.saving = true;
      let response = await this.$delete(`users/delete_request/` + id)
      vp.$notify.success('License request was successfully deleted')
      this.license_requests = response
      // this.saving = false;
    },
    async applyRequest (mac, exp, hdd) {
      let norm_format = moment(exp).format('YYYY-MM-DD')
      store.commit('setExpDate', norm_format)
      store.commit('setMac', mac)
      store.commit('setHdd', hdd)
    }
  }
}
</script>
<style scoped>
</style>
